export const stringify = (str = '') =>
  `${str}`
    .toLowerCase()
    .trim()
    // eslint-disable-next-line
    .replace(/[^\w\s\/\.-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
